import { render, staticRenderFns } from "./MailLink.vue?vue&type=template&id=4352cd08&"
import script from "./MailLink.vue?vue&type=script&lang=js&"
export * from "./MailLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4352cd08')) {
      api.createRecord('4352cd08', component.options)
    } else {
      api.reload('4352cd08', component.options)
    }
    module.hot.accept("./MailLink.vue?vue&type=template&id=4352cd08&", function () {
      api.rerender('4352cd08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f1zlIczwxeZa/JS/comp/MailLink.vue"
export default component.exports